import IconLogoBg from 'assets/img/logo_csz.png'
import { ReactNode } from 'react'
import { getQueryParams } from 'utils'
import { useLayoutWidth } from '../../hooks/useLayoutWidth'
import { LAYOUT_ID } from '../../Layout.model'
import * as Styled from './LayoutContainer.styled'

export function LayoutContainer({ children }: { children: ReactNode }) {
  const layoutWidth = useLayoutWidth()
  const { w, h } = getQueryParams()
  const width = w ? `${w}px` : '100%'
  const height = h ? `${h}px` : '100%'

  return (
    <Styled.Container $width={width} $height={height} id={LAYOUT_ID}>
      <Styled.InnerContainer $bgImage={IconLogoBg} $layoutWidth={layoutWidth}>
        {children}
      </Styled.InnerContainer>
    </Styled.Container>
  )
}
